export const VIEW_DEPLOYED_COURSE_CONSTANTS = {
  ViewDeployedCourseInstance: "View Deployed Course Instance",
  backToLibrary: "Back to Library Management",
  expandAll: "Expand All",
  collapseAll: "Collapse All",
  edit: "Edit",
  participantDetails: "Participant Details",
  generalDetails: "General Details",
  instanceName : "Instance Name :",
  description: "Description :",
  status: "Status :",
  courseTemplateAssociated : "Course Template Associated :",
  courseTemplatesAssociated : "Course Template Associated",
  courseType: "Course Type :",
  lastModifiedBy: "Last Modified By :",
  expiryDate: "Expiry Date :",
  emailStatus: "Email Status :",
  time: "Time :",
  duration: "Duration :",
  associatedVappTemplate: "Associated vApp Template :",
  filterBy: "Name",
  templateNameFilter: "Name",
  noFiltersApplied: "No filters applied",
  SearchByName: "Search by Name",
  SearchByOsType: "Search by OS Type",
  osTypeFilter: "OS Type",
  Invited_Student: "Invited Student",
  Assigned_Instructor: "Assigned Instructor",
  CourseDuration: "Course Duration :",
  Days: "Days",
  BACK_LINK_URL: "/academy/viewCourseTemplates",
  No_Students_Invited: "No Students Invited",
  No_Instructors_Assigned: "No Instructors Assigned",
  resultsRange: (from: number, to: number, total: number) => `${from}-${to} of ${total}`,
};